"use client";

import { ChartBar, Tags, Settings, Users, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
const services = [{
  id: 1,
  icon: Settings,
  title: "Ad Operations & Campaign Management",
  description: "Seamless, end-to-end campaign execution."
}, {
  id: 2,
  icon: Users,
  title: "Advertiser Success & Relationship Support",
  description: "Build strong, results-driven partnerships."
}, {
  id: 3,
  icon: ChartBar,
  title: "Analytics, Reporting & Insights",
  description: "Insights that guide smarter decisions."
}, {
  id: 4,
  icon: Tags,
  title: "Marketing Tagging, Conversion Tracking & Compliance",
  description: "Reliable tracking, fully compliant."
}, {
  id: 5,
  icon: Search,
  title: "Technical Audits & Optimization",
  description: "Maximize performance and revenue."
}];
export default function OurServices() {
  return <section className="bg-background py-20 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-4xl font-bold text-foreground mb-12 text-center">
          Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map(service => {
          const IconComponent = service.icon;
          return <div key={service.id} className="group flex flex-col gap-4 border-2 border-transparent rounded-lg p-6 transition-transform duration-[var(--duration-slow)] ease-[var(--ease-spring)] hover:-translate-y-2 hover:scale-105 hover:shadow-strong hover:bg-primary/5 hover:border-primary/30">
                <Link to="/ServicesPage" className="flex flex-col gap-4 no-underline">
                  <div className="flex items-center justify-center w-16 h-16 rounded-lg bg-primary/10 text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-110 group-hover:bg-primary/20 group-hover:rotate-6">
                    <IconComponent className="size-8" />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-foreground">
                    {service.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}